import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import Home from "@/pages/Home";
import DoubtClearing from "@/pages/DoubtClearing";
import CareerCounselling from "@/pages/CareerCounselling";
import CBSEClasses from "@/pages/CBSEClasses";
import BestCBSECoaching from "@/pages/BestCBSECoaching";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/doubt-clearing" element={<DoubtClearing />} />
          <Route path="/career-counselling" element={<CareerCounselling />} />
          <Route path="/cbse-classes-santacruz-west" element={<CBSEClasses />} />
          <Route path="/best-cbse-coaching-santacruz" element={<BestCBSECoaching />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppWidget />
    </BrowserRouter>
  );
}

export default App;
